// src/components/SystemRecommendation/components/ViewModeToggle.tsx

import React from 'react';
import { ViewMode } from '../types';

interface ViewModeToggleProps {
  currentMode: ViewMode;
  onToggle: (mode: ViewMode) => void;
  onGeneratePDF?: (mode: ViewMode) => void;
  technicalDisabled?: boolean;
  technicalDisabledReason?: string;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  currentMode,
  onToggle,
  onGeneratePDF,
  technicalDisabled = false,
  technicalDisabledReason
}) => {
  return (
    <div className="view-mode-toggle-container">
      <div className="view-mode-toggle">
        <button
          className={`toggle-button ${currentMode === 'customer' ? 'active' : ''}`}
          onClick={() => onToggle('customer')}
        >
          <span className="toggle-icon">👤</span>
          Customer View
        </button>

        <button
          className={`toggle-button ${currentMode === 'technical' ? 'active' : ''}`}
          disabled={technicalDisabled}
          title={technicalDisabled ? technicalDisabledReason : undefined}
          onClick={() => onToggle('technical')}
        >
          <span className="toggle-icon">📋</span>
          Survey View
        </button>
      </div>

      {technicalDisabled && technicalDisabledReason && (
        <div className="view-mode-warning">
          {technicalDisabledReason}
        </div>
      )}

      {onGeneratePDF && (
        <div className="pdf-actions">
          <button
            className="pdf-button"
            onClick={() => onGeneratePDF(currentMode)}
          >
            <span className="pdf-icon">📄</span>
            Generate PDF ({currentMode})
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewModeToggle;
